import { createDetailReducer } from 'Services/reducerCreator';

export default createDetailReducer({
  modelName: 'LINEUP_SURVEY'
});
